import { render, staticRenderFns } from "./SensitiveWordsManage.vue?vue&type=template&id=9d83469e&scoped=true&"
import script from "./SensitiveWordsManage.vue?vue&type=script&lang=js&"
export * from "./SensitiveWordsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d83469e",
  null
  
)

export default component.exports